import React from 'react'
import CommonScreen from 'admin/component/CommonScreen'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import * as api from '../../../api/pgads'

const additionalMonthlyTagsHeaders = [
  strCol({
    ident: 'header1',
    display: 'Header1',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal1', display: 'MinVal1', isFiltered: true }),
  numCol({ ident: 'maxVal1', display: 'MaxVal1', isFiltered: true }),
  strCol({
    ident: 'header2',
    display: 'Header2',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal2', display: 'MinVal2', isFiltered: true }),
  numCol({ ident: 'maxVal2', display: 'MaxVal2', isFiltered: true }),
  strCol({
    ident: 'header3',
    display: 'Header3',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal3', display: 'MinVal3', isFiltered: true }),
  numCol({ ident: 'maxVal3', display: 'MaxVal3', isFiltered: true }),
  strCol({
    ident: 'header4',
    display: 'Header4',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal4', display: 'MinVal4', isFiltered: true }),
  numCol({ ident: 'maxVal4', display: 'MaxVal4', isFiltered: true }),
  strCol({
    ident: 'header5',
    display: 'Header5',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal5', display: 'MinVal5', isFiltered: true }),
  numCol({ ident: 'maxVal5', display: 'MaxVal5', isFiltered: true }),
  strCol({
    ident: 'header6',
    display: 'Header6',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal6', display: 'MinVal6', isFiltered: true }),
  numCol({ ident: 'maxVal6', display: 'MaxVal6', isFiltered: true }),
  strCol({
    ident: 'header7',
    display: 'Header7',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal7', display: 'MinVal7', isFiltered: true }),
  numCol({ ident: 'maxVal7', display: 'MaxVal7', isFiltered: true }),
  strCol({
    ident: 'header8',
    display: 'Header8',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal8', display: 'MinVal8', isFiltered: true }),
  numCol({ ident: 'maxVal8', display: 'MaxVal8', isFiltered: true }),
  strCol({
    ident: 'header9',
    display: 'Header9',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal9', display: 'MinVal9', isFiltered: true }),
  numCol({ ident: 'maxVal9', display: 'MaxVal9', isFiltered: true }),
  strCol({
    ident: 'header10',
    display: 'Header10',
    isFiltered: true,
    width: 150,
  }),
  numCol({ ident: 'minVal10', display: 'MinVal10', isFiltered: true }),
  numCol({ ident: 'maxVal10', display: 'MaxVal10', isFiltered: true }),
  strCol({
    ident: 'header11',
    display: 'Header11',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'header12',
    display: 'Header12',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'header13',
    display: 'Header13',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'header14',
    display: 'Header14',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'header15',
    display: 'Header15',
    isFiltered: true,
    width: 150,
  }),
]
const title = 'Additional Monthly Tags'

const AdditionalMonthlyTags = () => (
  <CommonScreen
    title={title}
    isAdminScreen
    header={additionalMonthlyTagsHeaders}
    saveTask={api.saveAdditionalMonthlyTags}
    retrieveTask={api.getAdditionalMonthlyTags}
    autoRetrieve
    sortOptions={additionalMonthlyTagsHeaders}
    widthOffset={100}
    autoFixColByKey={false}
    headerRowHeight={60}
    allowInsert={false}
    withDelete={false}
  />
)

export default AdditionalMonthlyTags
